// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__3fLUY","form":"styles_form__vDiOu"};